import { motion } from "framer-motion";
import { Eyebrow } from "@/components/Section";
import { Blob } from "@/components/Decor";

export const PageHero = ({ eyebrow, title, desc, testId, tone = "#C26D52", image, aside }) => (
  <section data-testid={testId} className="relative mesh-hero grain overflow-hidden pt-36 pb-16 lg:pt-44 lg:pb-24">
    <div className="perspective-grid" />
    <Blob color={`${tone}2E`} className="-top-32 right-[8%]" size={560} />
    <Blob color="rgba(44,74,111,0.14)" className="bottom-[-30%] left-[-8%]" size={520} />
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className={image || aside ? "lg:col-span-7" : "lg:col-span-9"}
        >
          <Eyebrow tone={tone}>{eyebrow}</Eyebrow>
          <h1 className="mt-7 font-display text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight leading-[1.06] text-[#0E1B31]">{title}</h1>
          {desc && <p className="mt-7 text-base sm:text-lg leading-relaxed text-[#3B4A5E] max-w-2xl">{desc}</p>}
        </motion.div>
        {(image || aside) && (
          <motion.div
            initial={{ opacity: 0, y: 30, rotate: -1 }}
            animate={{ opacity: 1, y: 0, rotate: 0 }}
            transition={{ duration: 1, delay: 0.25, ease: [0.22, 1, 0.36, 1] }}
            className="lg:col-span-5 relative"
          >
            {image && (
              <div className="relative">
                <div className="absolute -inset-3 rounded-[34px] rotate-2" style={{ background: `linear-gradient(135deg, ${tone}33, transparent)` }} />
                <img src={image} alt="" className="relative h-[260px] lg:h-[320px] w-full rounded-[28px] object-cover shadow-[0_40px_80px_-40px_rgba(14,27,49,0.45)]" />
              </div>
            )}
            {aside}
          </motion.div>
        )}
      </div>
    </div>
  </section>
);
